const LICENSED_USERS_URL = 'https://graph.microsoft.com/v1.0/users?$count=true&$filter=assignedLicenses/$count ne 0&$select=id';
const SUBSCRIBED_SKUS_URL = 'https://graph.microsoft.com/v1.0/subscribedSkus';

const FREE_SKU_KEYWORDS = [
    'FREE',
    'VIRAL',
    'TRIAL',
    'INTERNAL',
    'DEVELOPERPACK',
    'VIRTUALUSER',
    'ROOMS'
];

const createGraphError = async (response, label) => {
    let details = {};
    try {
        details = await response.json();
    } catch {
        details = {};
    }

    const graphError = details.error || {};
    const message = graphError.message || response.statusText || `HTTP ${response.status}`;
    const error = new Error(`Microsoft Graph ${label} request failed: ${message}`);
    error.status = response.status;
    error.code = graphError.code;
    error.details = details;
    return error;
};

const fetchGraphJson = async ({ accessToken, fetchImpl, url, label }) => {
    const response = await fetchImpl(url, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ConsistencyLevel: 'eventual'
        }
    });

    if (!response.ok) {
        throw await createGraphError(response, label);
    }

    return response.json();
};

const getLicensedUserCount = (usersData = {}) => {
    if (usersData['@odata.count'] !== undefined) {
        return usersData['@odata.count'];
    }

    return Array.isArray(usersData.value) ? usersData.value.length : null;
};

const isPaidUserSku = (sku = {}) => {
    const partNumber = String(sku.skuPartNumber || '').toUpperCase();
    const enabledSeats = Number(sku.prepaidUnits?.enabled || 0);
    const isFreeSku = FREE_SKU_KEYWORDS.some(keyword => partNumber.includes(keyword));
    const isUnlimitedSku = enabledSeats >= 10000;

    return !isFreeSku && !isUnlimitedSku && sku.capabilityStatus === 'Enabled';
};

const getPaidSeatCount = (skus = []) => skus
    .filter(isPaidUserSku)
    .reduce((sum, sku) => sum + Number(sku.prepaidUnits?.enabled || 0), 0);

export const fetchMicrosoftLicenseData = async ({
    accessToken,
    fetchImpl = fetch,
    logger = console
}) => {
    const usersData = await fetchGraphJson({
        accessToken,
        fetchImpl,
        url: LICENSED_USERS_URL,
        label: 'licensed users'
    });

    const result = {
        licensedUsers: getLicensedUserCount(usersData),
        paidSeats: null
    };

    try {
        const skusData = await fetchGraphJson({
            accessToken,
            fetchImpl,
            url: SUBSCRIBED_SKUS_URL,
            label: 'subscribedSkUs'
        });

        if (Array.isArray(skusData.value)) {
            result.paidSeats = getPaidSeatCount(skusData.value);
        }
    } catch (error) {
        logger.warn('Microsoft Graph subscribedSkus request failed', error);
    }

    return result;
};
